/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <public-title>销售列表
      <el-button  type="success" @click="addPosition" slot="right" class="ml-auto">邀请销售</el-button>
    </public-title>
    <div class="load-area"  v-loading="loading">
      <el-tabs v-model="activeTab" class="mb-4" @tab-click="currentPage=1;getLists()" v-show="isAdmin">
        <el-tab-pane :label="item.name" :name="item.id" :key="item.name" v-for="item in $GVAR.StoreTypeStr"/>
      </el-tabs>
      <p v-if="salesAssociationLists.total<=0">当前没有数据</p>
      <div v-else>
        <ul class="list-head">
          <li :class="item.width" v-for="item in titleArr" :key="item.name" v-if="activeName!=item.show">
            {{item.name}}
          </li>
        </ul>
        <ul class="list-item"  v-for="Itemize in salesAssociationLists.lists" :key="Itemize.id" v-if="Itemize.level!=2">
          <li class="w-50 list-item-col">{{Itemize.truename}}</li>
          <li class="w-50 list-item-col">{{Itemize.mobile}}</li>
          <li class="w-50 list-item-col" v-if="activeName!=1">{{Itemize.add_time | formatTimestamp(1)}}</li>
          <li class="w-50 list-item-col">
             <div class="rimary" :class="$GFUN.correlationColor(Itemize.status)">{{Itemize.status  | formatVar('AssociatedState')}}</div>
          </li>
          <li  class="w-20 list-item-col-end">
              <el-button type="danger" @click="deleteItem(Itemize)" size="mini">解除销售</el-button>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="salesAssociationLists.total" :current-page="Number(queryCon.page)"
                       @current-change="v => this.currentPage=v"/>
      </div>
    </div>
    <el-dialog title="邀请微信二维码" :visible.sync="QRcodeShwo" width="600px" center id="loadConfirm"  top="36vh">
        <img :src="backgroundImage" alt="二维码" class="remove-margin" v-if="backgroundImage"/>
        <div class="formbuttton">
          复制二维码分享邀请销售、微信扫码并进行关联操作!
          <!-- <el-button type="primary" @click="copyText(share.pay_url)">一键复制</el-button> -->
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { data } from 'jquery';
import { mapGetters, mapActions,mapState } from 'vuex'

  export default {
    name: 'Lists',
    computed: {
      ...mapState(['salesAssociationLists','positionDetail','userLoginMessage']),
      ...mapGetters(['storeInfo','isGroup','userInfo','isAdmin']),
      powerArr() { return this.positionDetail.power_arr },
      queryCon() { return this.$route.query },
    },
    watch:{
        queryCon() { this.getLists(); },
      currentPage() { this.$router.push({name:this.$route.name,query:{...this.queryCon,page:this.currentPage}}) }
    },
    data() {
      return {
        titleArr:[
          {name:'销售名称',width:'w-50'},
          {name:'销售手机号',width:'w-50'},
          {name:'状态',width:'w-50'},
          {name:'操作',width:'w-20'},
        ],
        currentPage:1,
        PopArr: [],
        activeTab:'1',
        showAccess:false,           //展示账号权限
        defaultProps: {
          children: 'children',
          label: 'title'
        },
        activeName:'1',             //当前tab值
        loading: false,
        backgroundImage:'',
        QRcodeShwo:false,
      }
    },
    mounted() {
      this.getLists();
    },
    methods:{
      ...mapActions(['POST_UnionRecordEnterpriseList','POST_UnionRemove',"POST_GetInviteUnionQRCode"]),
      // 切换酒店Tab
      handleClick (e) {
        console.log(e);
        this.activeName = e.name;
        this.getLists();
      },
      getLists() {
        let data = {
          status:this.activeName,
          ...this.queryCon,
          page:this.currentPage
        };
        this.loading = true;
        this.POST_UnionRecordEnterpriseList({data,successFun:()=>{this.loading = false;}});
      },
      //解除关联
      deleteItem(item,i) {
        let data={
          uid:item.uid,
          store_type:this.storeInfo.type
        }
        this.POST_UnionRemove({data,
            successFun: () => {
              this.$message.success('操作成功');
              this.getLists();
            },
        });
      },
      addPosition(){
        if(this.backgroundImage!=''){
            this.QRcodeShwo = true;
            return
        }
        let storeInfo=this.storeInfo;
        this.POST_GetInviteUnionQRCode({
          data: {store_id:storeInfo.storeId,store_type:storeInfo.type},
          successFun: (res) => {
            this.QRcodeShwo = true;
            this.backgroundImage = 'data:image/jpeg;base64,'+res.qr_code;
          },
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
      .activeName  {
        background-color: #fff;
        float: left;
    }
    .activ{
        overflow: hidden;
    }
.scroll{
  min-height: 45px;
  max-height: 50vh
}
.view-box{
  border: 1px solid red
}
.ntm{
  float: left;
}
.fls{
  float: left;
}
.nnsp{
  overflow: hidden;
}
.formbuttton{
  display: flex;
  justify-content: center;
}
.remove-margin{
  margin: 0 auto;
  display: block;
  margin-bottom: 20px;
}
</style>